module.exports = "/images/role-designer-icon.svg?a14671c2f79738f712f84446b4e58b92";